import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/components/index'
import Iogin from '@/components/login'
import Register from '@/components/register'
import Details from '@/components/details'
import IsShoppingCart from '@/components/ShoppingCart'
import PersonalCenter from '@/components/personalCenter'
import Focusoncommodities from '@/components/focusoncommodities'
import ListOfCommodities from '@/components/ListOfCommodities'
import ArticleDetails from '@/components/ArticleDetails'
import Article from '@/components/Article'
import tesegou from '@/components/tesegou'
import tesegou1 from '@/components/tesegou1'
import tesegou2 from '@/components/tesegou2'
import jifen from '@/components/jifen'
import dingzhi from '@/components/dingzhi'
import dingzhigengduo from '@/components/dingzhigengduo'
import bannerShop from '@/components/bannerShop'
import bannerShop1 from '@/components/bannerShop1'
import bannerShop2 from '@/components/bannerShop2'
import jiejue from '@/components/jiejue'
import Detailsjifen from '@/components/detailsjifen'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component: Index
    },
    {
      path: '/login',
      name: 'login',
      component: Iogin
    },
    {
      path: '/tesegou1',
      name: 'tesegou1',
      component: tesegou1
    },
    {
      path: '/tesegou2',
      name: 'tesegou2',
      component: tesegou2
    },
    {
      path: '/bannerShop2',
      name: 'bannerShop2',
      component: bannerShop2
    },
    {
      path: '/ListOfCommodities',
      name: 'ListOfCommodities',
      component: ListOfCommodities
    },
    {
      path: '/register',
      name: 'register',
      component: Register
    },
    {
      path: '/details',
      name: 'details',
      component: Details
    },
    {
      path: '/detailsjifen',
      name: 'detailsjifen',
      component: Detailsjifen
    },
    {
      path: '/ShoppingCart',
      name: 'ShoppingCart',
      component: IsShoppingCart
    },
    {
      path: '/personalCenter',
      name: 'personalCenter',
      component: PersonalCenter
    },
    {
      path: '/focusoncommodities',
      name: 'focusoncommodities',
      component: Focusoncommodities
    },
    {
      path: '/ArticleDetails',
      name: 'ArticleDetails',
      component: ArticleDetails
    },
    {
      path: '/Article',
      name: 'Article',
      component: Article
    },
    {
      path: '/tesegou',
      name: 'tesegou',
      component: tesegou
    },
    {
      path: '/jifen',
      name: 'jifen',
      component: jifen
    },
    {
      path: '/dingzhi',
      name: 'dingzhi',
      component: dingzhi
    },
    {
      path: '/dingzhigengduo',
      name: 'dingzhigengduo',
      component: dingzhigengduo
    },
    {
      path: '/bannerShop',
      name: 'bannerShop',
      component: bannerShop
    },
    {
      path: '/bannerShop1',
      name: 'bannerShop1',
      component: bannerShop1
    },
    {
      path: '/jiejue',
      name: 'jiejue',
      component: jiejue
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js